/* eslint-disable array-callback-return */
import React, { useState } from "react";
import { Trash, MessageCircle, ThumbsUp } from "lucide-react";
import { Modal, Button, Form } from "react-bootstrap";
import { PostComments, PostLike } from "../../services/collectionsService";
const ColllectionsCollabrate = ({
  src,
  data,
  deleteFnc,
  name = "UnKnown",
  iscollabrate,
  user,
}) => {
  const likes = data?.likes;
  const userId = user?.id;
  const forename = user?.forename;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comments, setComments] = useState(data?.comments);
  const [newComment, setNewComment] = useState("");
  const userLiked = likes?.some((like) => like.user_id === userId);
 
  const [isLiked, setIsLiked] = useState(userLiked);
  const [likeCount, setLikeCount] = useState(data?.likes_count);

  const handleLikeToggle = async (id) => {
    if (isLiked) {
      setLikeCount(likeCount - 1);
      try {
        await PostLike("unlike", id);
      } catch (err) {
      } finally {
      }
    } else {
      try {
        await PostLike("like", id);
      } catch (err) {
      } finally {
      }
      setLikeCount(likeCount + 1);
    }
    setIsLiked(!isLiked);
  };

  const handleAddComment = async (id) => {
    if (newComment.trim()) {
      setComments([
        ...comments,
        { user: forename, comment: newComment, user_id: userId },
      ]);
      setNewComment("");
      try {
        await PostComments(newComment, id);
      } catch (err) {
      } finally {
      }
    }
  };

  return (
    <>
      <div className="card_action">
        <div className="flex flex-col ">
          <div
            id={`delete`}
            className="tw-cursor-pointer"
            onClick={() => deleteFnc(data.id)}
          >
            <Trash color="red" />
          </div>
        </div>
      </div>
      <div className="d-flex flex-column align-items-center py-3 border rounded shadow-sm">
        <div className="nft__item" style={{ border: "none" }}>
          <div className="nft__item_wrap">
            <img src={src} className="image-cover" alt={`alt-${name}`} />
          </div>
          <div className="nft__item_info">
            <h2 className="text-center w-100">{name}</h2>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            variant=""
            className="d-flex align-items-center gap-1"
            onClick={() => handleLikeToggle(data?.id)}
          >
            <ThumbsUp size={18} color={isLiked ? "blue" : "gray"} />
            <span className={isLiked ? "text-blue" : "text-muted"}>
              {isLiked ? "Like" : "UnLike"} ({likeCount})
            </span>
          </Button>
          <Button
            variant=""
            className="d-flex align-items-center gap-1"
            onClick={() => setIsModalOpen(true)}
          >
            <MessageCircle size={18} /> <span>Comment ({data?.comments_count})</span>
          </Button>
          {/* <Button
            variant=""
            className="d-flex align-items-center gap-1"
            onClick={() => console.log("Shared")}
          >
            <Share2 size={18} /> <span>Share</span>
          </Button> */}
        </div>
      </div>

      {/* Comments Modal */}
      <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-3">
            {comments.map((comment, index) => {
              const isUserComment = comment.user_id === userId;
              return (
                <div
                  key={index}
                  style={{
                    width: "70%",
                    alignSelf: isUserComment ? "flex-end" : "flex-start",
                    backgroundColor: isUserComment ? "#007bff" : "#f8f9fa",
                    color: isUserComment ? "#fff" : "#000",
                  }}
                  className="p-2  rounded d-flex flex-column"
                >
                  <strong>{comment?.user?.forename}</strong>
                  <span>{comment?.comment}</span>
                </div>
              );
            })}
            <Form.Control
              type="text"
              placeholder="Write a comment..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              className="mt-2"
            />
            <Button
              variant="primary"
              className="mt-2"
              onClick={() => handleAddComment(data?.id)}
            >
              Post Comment
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ColllectionsCollabrate;
